export enum EventRSVPConfirmationPageSectionType {
  MAIN = 'MAIN',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  CREATE_EVENT = 'CREATE_EVENT',
  HOST = 'HOST',
  FOOTER = 'FOOTER',
}
